import { FormattedMessage } from "react-intl";
import { Title, Subtitle } from "./styles";

const TITLE_TEXT = {
  0: (
    <FormattedMessage
      id="design_my_screen_modal.title.step1_updated"
      defaultMessage="Most popular templates for your industry"
    />
  ),
  1: (
    <FormattedMessage
      id="design_my_screen_modal.title.step2"
      defaultMessage="Personalize your style!"
    />
  ),
  2: (
    <FormattedMessage
      id="design_my_screen_modal.title.step3"
      defaultMessage="Which layout style would you prefer for your content?"
    />
  ),
};

const SUBTITLE_TEXT = {
  0: (
    <FormattedMessage
      id="design_my_screen_modal.subtitle.step1_updated"
      defaultMessage="Select one or more options below so we can help you customise the templates for your channel. You can fully customise later!"
    />
  ),
  1: (
    <FormattedMessage
      id="design_my_screen_modal.subtitle.step2"
      defaultMessage="Customize your details below to align your screens with your brand."
    />
  ),
  2: (
    <FormattedMessage
      id="design_my_screen_modal.subtitle.step3"
      defaultMessage="Select a design that elevates your content and maximizes your screen positioning, ensuring eyes are glued to your screens! Don't worry, you can easily change this later"
    />
  ),
};

interface TitleTextProps {
  currentStepIndex: number;
  displayTitleText?: boolean;
  titleText?: string;
  subtitleText?: string;
}

export const TitleText = ({
  currentStepIndex,
  displayTitleText = true,
  titleText,
  subtitleText,
}: TitleTextProps) => {
  if (currentStepIndex === 0 && !displayTitleText) {
    return null;
  }

  return (
    <>
      <Title data-testid="title">
        {titleText || TITLE_TEXT[currentStepIndex]}
      </Title>
      <Subtitle data-testid="subtitle">
        {subtitleText || SUBTITLE_TEXT[currentStepIndex]}
      </Subtitle>
    </>
  );
};
